import { render, staticRenderFns } from "./GastosCategoriaSelect.vue?vue&type=template&id=75bdbfd9&scoped=true&"
import script from "./GastosCategoriaSelect.vue?vue&type=script&lang=js&"
export * from "./GastosCategoriaSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75bdbfd9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VContainer,VDialog,VIcon,VSelect,VSpacer})
